import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import {HeadlineH2} from '../Text';
import itemIsInList from '../../utils/itemIsInList';

const Snippet = styled.div`
  margin: 15px 15px 0 0;
  cursor: pointer;
  border: ${props => (props.selected ? '4px solid ' + props.theme.primary1Color : '2px solid #eee')};
  width: 400px;
  padding: 15px;
  display: inline-block;
  max-height: 150px;
  overflow: hidden;
  p {
    font-weight: bold;
  }
`;

const SnippetSelect = ({title, allSnippets, selectedSnippets, toggleSnippet}) => {
  let snippets = 'no snippets available';

  if (allSnippets && allSnippets.length) {
    snippets = allSnippets.map(snippet => (
      <Snippet
        key={'selected_' + snippet._id}
        selected={itemIsInList(selectedSnippets, snippet)}
        onClick={() => {
          toggleSnippet(snippet);
        }}>
        <p>{snippet.title}</p>
        {/*<div dangerouslySetInnerHTML={{__html: snippet.description}} />*/}
      </Snippet>
    ));
  }

  return (
    <div>
      <HeadlineH2>{title}</HeadlineH2>
      <div>{snippets}</div>
    </div>
  );
};

SnippetSelect.propTypes = {
  allSnippets: PropTypes.array.isRequired,
  selectedSnippets: PropTypes.array.isRequired,
  toggleSnippet: PropTypes.func.isRequired,
};

export default SnippetSelect;



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/Content/SnippetSelect.js